const ICON_LAYER = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      fill={color}
      stroke="none"
      d="M.177 3.504 4.571.137a.74.74 0 0 1 .856 0l4.394 3.367c.237.182.237.474 0 .656L5.427 7.527a.74.74 0 0 1-.856 0L.177 4.16c-.237-.182-.237-.474 0-.656z"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      fill={color}
      stroke="none"
      d="m.602 5.514-.425.326c-.237.182-.237.475 0 .656l4.394 3.368a.74.74 0 0 0 .857 0L9.82 6.496c.237-.181.237-.474 0-.656l-.426-.326-3.967 3.04a.74.74 0 0 1-.857 0z"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_LAYER;
